module.exports = __webpack_public_path__ + "media/images/org-0c2960430f6288a5c08f1a2dacf81894.png";